import React, { ReactNode } from 'react';
import { Avatar, Box, Divider, Paper, Stack, Typography } from '@mui/material';
import { getFrontendURL } from 'src/utils/url';
import { theme } from 'src/theme/mui-theme';
import { DEFAULT_SPACING } from 'src/theme/style-consts';

export type UserCardRow = {
    label: string;
    value: string | null;
};

type Props = {
    title: string;
    titleAction?: ReactNode;
    actions?: ReactNode;
    avatarLink: string | null;
    rows: UserCardRow[];
};

export const UserCard = ({ title, titleAction, actions, avatarLink, rows }: Props) => {
    const avatarSrc = avatarLink ? `${getFrontendURL()}/images/avatars/${avatarLink}` : undefined;

    return (
        <Paper variant="outlined" sx={{ padding: DEFAULT_SPACING }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ minHeight: 32 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {title}
                    </Typography>
                    {titleAction}
                </Stack>
                {actions}
            </Stack>
            <Divider sx={{ marginY: DEFAULT_SPACING }} />
            <Stack direction="row" spacing={2}>
                <Avatar src={avatarSrc} sx={{ width: 56, height: 56 }} />
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'auto 1fr',
                        columnGap: 1,
                        rowGap: 0.5,
                        minWidth: 0,
                    }}
                >
                    {rows.map((row) => (
                        <React.Fragment key={row.label}>
                            <Typography variant="body2" color={theme.palette.text.secondary}>
                                {row.label}:
                            </Typography>
                            <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
                                {row.value}
                            </Typography>
                        </React.Fragment>
                    ))}
                </Box>
            </Stack>
        </Paper>
    );
};
